const FinderTypes = Object.freeze({
  object: "object",
  array: "array",
  element: "element",
});

export default FinderTypes;
